// ================================================================
// Start Node — Configuration Schema
// ================================================================
// Start فقط trigger هست — فیلد تنظیمات نداره.
// کلیک روش Picker (Add a module) رو باز می‌کنه.

export const startConfigSchema = {
  fields: []
};

// helper برای FieldRenderer (هنوز استفاده می‌شه)
export function shouldShowField(field, config) {
  if (!field.showIf) return true;
  return Object.entries(field.showIf).every(([key, expectedValue]) => {
    // '*' یعنی هر مقدار غیرخالی (نه یک مقدار خاص)
    if (expectedValue === '*') {
      const v = config[key];
      return v !== undefined && v !== null && v !== '';
    }
    return config[key] === expectedValue;
  });
}

export function cleanInvalidValues(schema, config) {
  const cleaned = { ...config };
  schema.fields.forEach(field => {
    if (!shouldShowField(field, cleaned)) {
      delete cleaned[field.key];
    }
  });
  return cleaned;
}
